import React, { useEffect, useRef, useState } from "react";
import JsBarcode from "jsbarcode";

const BarcodeLabel = React.forwardRef((props, ref) => {
  const [config, setConfig] = useState(null); // Store the config
  const barcodeRefs = useRef([React.createRef(), React.createRef()]);

  // Fetch config.json file
  useEffect(() => {
    fetch("/config.json")
      .then((response) => response.json())
      .then((data) => {
        setConfig(data); // Set the fetched config data
      })
      .catch((error) => {
        console.error("Error fetching configuration:", error);
      });
  }, []);

  useEffect(() => {
    if (config) {
      // Generate barcodes for visible labels
      const refsToUse = props.isPair
        ? barcodeRefs.current
        : [barcodeRefs.current[0]];
      refsToUse.forEach((barcodeRef) => {
        JsBarcode(barcodeRef.current, props.barcodeValue, {
          format: "CODE128",
          width: 1,
          height: 30,
          fontSize: 8,
          displayValue: false,
        });
      });
    }
  }, [props.barcodeValue, config, props.isPair]);

  if (!config) {
    return <div>Loading configuration...</div>; // Display loading until config is fetched
  }

  const {
    container,
    labelBox,
    headerPanel,
    gapBetweenLabel,
    bodyPanel,
    footerPanel,
  } = config;

  const Label = ({ barcodeRef }) => (
    <div
      style={{
        width: labelBox.width,
        height: labelBox.height,
        border: labelBox.border === "yes" ? "1px solid black" : "none",
        borderRadius: "5px",
        textAlign: "center",
        fontSize: 10,
        fontWeight: "bolder",
        paddingTop: labelBox.paddingTop,
        paddingLeft: labelBox.paddingLeft,
        paddingBottom: labelBox.paddingBottom,
      }}
    >
      <div
        style={{
          textAlign: "center",
          paddingTop: headerPanel.paddingTop,
          paddingLeft: headerPanel.paddingLeft,
          paddingBottom: headerPanel.paddingBottom,
        }}
      >
        ADI GOLD FASHION & CO.
      </div>
      <div
        style={{
          fontSize: 11,
          fontWeight: "bolder",
          textAlign: "left",
          paddingTop: bodyPanel.paddingTop,
          paddingLeft: bodyPanel.paddingLeft,
          paddingBottom: bodyPanel.paddingBottom,
        }}
      >
        <table>
          <tbody>
            <tr style={{ height: "3px" }}>
              <td style={{ lineHeight: 1 }}>D. No.</td>
              <td style={{ lineHeight: 1 }}>- {props.batch}</td>
            </tr>
            <tr style={{ height: "3px" }}>
              <td style={{ lineHeight: 1 }}>Size</td>
              <td style={{ lineHeight: 1 }}>- {props.size}</td>
            </tr>
            <tr style={{ height: "3px" }}>
              <td style={{ lineHeight: 1 }}>Style</td>
              <td style={{ lineHeight: 1 }}>- {props.style}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <svg
        ref={barcodeRef}
        style={{ maxWidth: "200px", width: "100%", height: "40px" }}
      />
      <div
        style={{
          fontSize: 9,
          textAlign: "center",
          paddingTop: footerPanel.paddingTop,
          paddingLeft: footerPanel.paddingLeft,
          paddingBottom: footerPanel.paddingBottom,
        }}
      >
        {props.special_code}
      </div>
    </div>
  );

  return (
    <div
      ref={ref}
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        width: container.width,
        height: container.height,
        border: container.border === "yes" ? "1px solid black" : "none",
        paddingTop: container.paddingTop,
        paddingLeft: container.paddingLeft,
        paddingBottom: container.paddingBottom,
        FontFace: "Courier",
      }}
    >
      <Label barcodeRef={barcodeRefs.current[0]} />
      {props.isPair && (
        <>
          <div style={{ paddingLeft: gapBetweenLabel.paddingLeft }}></div>
          <Label barcodeRef={barcodeRefs.current[1]} />
        </>
      )}
    </div>
  );
});

export default BarcodeLabel;
